import {
  FIELD_ORDER_UI_SCHEMA_KEY,
  SECTION_NAME_UI_SCHEMA_KEY,
  INFO_TEXT_UI_SCHEMA_KEY,
  StepConfigEditorOverride,
  SHOW_DIVIDER_LINE_KEY,
  ShapeUISchemaV2NestedShapeValues,
} from '../../StepConfigEditorTypes';

/**
 * Heatmap configuration sections for the Configure tab
 */
export const HEATMAP_CONFIG_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['configSection'],
  configSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['rows', 'columns', 'metric', 'gradientDirection'],
    rows: {
      displayName: 'Rows',
      configShapePath: ['chartConfig', 'parameters', 'yAxisColumnName'],
    },
    columns: {
      displayName: 'Columns',
      configShapePath: ['chartConfig', 'parameters', 'xAxisColumnName'],
    },
    metric: {
      displayName: 'Metric',
      configShapePath: ['chartConfig', 'parameters', 'metricColumnName'],
    },
    gradientDirection: {
      displayName: 'Gradient direction',
      configShapePath: ['chartConfig', 'parameters', 'gradientDirection'],
      fieldSettings: {
        displayNames: {
          ASCENDING_METRIC_VALUES: 'Ascending',
          DESCENDING_METRIC_VALUES: 'Descending',
        },
      },
    },
  },
} as const satisfies ShapeUISchemaV2NestedShapeValues;

export const HEATMAP_STYLE_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['legendSection'],
  legendSection: {
    [SECTION_NAME_UI_SCHEMA_KEY]: 'Legend',
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['showLegend', 'position', 'customLabel'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    [INFO_TEXT_UI_SCHEMA_KEY]: 'A series column must be selected to show a legend.',
    showLegend: {
      configShapePath: ['chartConfig', 'parameters', 'showLegend'],
      editorOverride: StepConfigEditorOverride.CHECKBOX,
      fieldSettings: {
        checkboxLabel: 'Show legend',
        defaultValue: true,
      },
    },
    position: {
      displayName: 'Position',
      configShapePath: ['chartConfig', 'parameters', 'legendLocation'],
      fieldSettings: {
        displayNames: {
          TOP: 'Top',
          LEFT: 'Left',
          RIGHT: 'Right',
        },
      },
    },
    customLabel: {
      displayName: 'Custom label (optional)',
      configShapePath: ['chartConfig', 'parameters', 'legendLabel'],
    },
  },
} as const satisfies ShapeUISchemaV2NestedShapeValues;
